<template>
    <div class="offer-details" :class="{'tooltip-btn': tooltip, 'online': isOnlineGame && !tooltip}" v-if="offer?.id">
        <button @click="showModalOfferInfo = true">
            <svg v-if="isHead" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.72363 11.8847C3.73952 10.1659 5.18442 8.56631 6.82873 7.40368C8.47782 6.23767 10.272 5.54839 12 5.54839C13.728 5.54839 15.5222 6.23766 17.1712 7.40379C18.8156 8.56659 20.2606 10.1665 21.2765 11.8859C21.318 11.9566 21.318 12.0441 21.2766 12.1149C20.2607 13.8338 18.8157 15.4336 17.1713 16.5963C15.5222 17.7623 13.728 18.4516 12 18.4516C10.272 18.4516 8.47784 17.7623 6.82876 16.5962C5.18443 15.4334 3.7395 13.8336 2.7236 12.1142C2.68192 12.0434 2.68193 11.9555 2.72363 11.8847ZM2.72363 11.8847C2.72366 11.8846 2.7237 11.8846 2.72373 11.8845L1.97904 11.5169L2.72335 11.8851C2.72345 11.885 2.72354 11.8848 2.72363 11.8847ZM12 4C9.78484 4 7.63582 4.87614 5.79388 6.17851C3.9473 7.48416 2.35341 9.25576 1.2347 11.1487L1.23432 11.1493C0.921893 11.6791 0.921893 12.3198 1.23432 12.8497L1.23465 12.8502C2.35335 14.7437 3.94725 16.5155 5.79385 17.8213C7.63581 19.1239 9.78484 20 12 20C14.2152 20 16.3642 19.1239 18.2061 17.8215C20.0527 16.5158 21.6466 14.7442 22.7653 12.8513L22.7657 12.8507C23.0781 12.3209 23.0781 11.6802 22.7657 11.1503L22.7654 11.1498C21.6466 9.25634 20.0528 7.48446 18.2062 6.17866C16.3642 4.87614 14.2152 4 12 4ZM10.1765 10.3316C11.1836 9.41022 12.8164 9.41022 13.8235 10.3316C14.8306 11.253 14.8306 12.747 13.8235 13.6684C12.8164 14.5898 11.1836 14.5898 10.1765 13.6684C9.16943 12.747 9.16943 11.253 10.1765 10.3316ZM9.0368 9.28888C10.6733 7.79156 13.3267 7.79156 14.9632 9.28888C16.5997 10.7862 16.5997 13.2138 14.9632 14.7111C13.3267 16.2084 10.6733 16.2084 9.0368 14.7111C7.40027 13.2138 7.40027 10.7862 9.0368 9.28888Z" fill="#C9C9C9"/>
            </svg>
            <span v-else-if="tooltip">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 12C2 12 5.75 5.125 12 5.125C18.25 5.125 22 12 22 12C22 12 18.25 18.875 12 18.875C5.75 18.875 2 12 2 12ZM12 16.375C13.1603 16.375 14.2731 15.9141 15.0936 15.0936C15.9141 14.2731 16.375 13.1603 16.375 12C16.375 10.8397 15.9141 9.72688 15.0936 8.90641C14.2731 8.08594 13.1603 7.625 12 7.625C10.8397 7.625 9.72688 8.08594 8.90641 8.90641C8.08594 9.72688 7.625 10.8397 7.625 12C7.625 13.1603 8.08594 14.2731 8.90641 15.0936C9.72688 15.9141 10.8397 16.375 12 16.375Z" fill="#9D9D9D"/>
                    <path d="M15.125 12C15.125 12.8288 14.7958 13.6237 14.2097 14.2097C13.6237 14.7958 12.8288 15.125 12 15.125C11.1712 15.125 10.3763 14.7958 9.79029 14.2097C9.20424 13.6237 8.875 12.8288 8.875 12C8.875 11.1712 9.20424 10.3763 9.79029 9.79029C10.3763 9.20424 11.1712 8.875 12 8.875C12.8288 8.875 13.6237 9.20424 14.2097 9.79029C14.7958 10.3763 15.125 11.1712 15.125 12Z" fill="#9D9D9D"/>
                </svg>
                {{ $t('Offer Details') }}
            </span>
            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.47583 12.9375V12.942C4.45057 13.0373 4.40677 13.1266 4.34695 13.205C4.28713 13.2833 4.21246 13.3491 4.1272 13.3985C4.04194 13.448 3.94777 13.4801 3.85008 13.4932C3.75238 13.5062 3.65307 13.4999 3.55783 13.4745C2.91133 13.3035 3.02533 12.558 3.02533 12.558L3.05233 12.465C3.05233 12.465 3.09133 12.339 3.12283 12.2475C3.50776 11.1682 4.07443 10.1627 4.79833 9.2745C6.14383 7.6335 8.40733 6 11.9998 6C15.5923 6 17.8558 7.6335 19.2028 9.2745C19.9267 10.1627 20.4934 11.1682 20.8783 12.2475C20.9106 12.3402 20.9406 12.4338 20.9683 12.528L20.9728 12.5475V12.5535L20.9743 12.5565C21.0219 12.7474 20.9926 12.9493 20.8926 13.1188C20.7927 13.2883 20.6302 13.4117 20.4401 13.4625C20.25 13.5132 20.0476 13.4873 19.8765 13.3902C19.7054 13.2931 19.5793 13.1327 19.5253 12.9435L19.5238 12.9375L19.5118 12.9L19.4593 12.7365C19.1324 11.8253 18.6531 10.9762 18.0418 10.2255C16.9288 8.868 15.0673 7.5 11.9998 7.5C8.93233 7.5 7.07233 8.868 5.95783 10.2255C5.34658 10.9762 4.86726 11.8253 4.54033 12.7365L4.48783 12.9L4.47583 12.9375ZM11.9998 10.5C11.0053 10.5 10.0514 10.8951 9.34818 11.5983C8.64492 12.3016 8.24983 13.2554 8.24983 14.25C8.24983 15.2446 8.64492 16.1984 9.34818 16.9017C10.0514 17.6049 11.0053 18 11.9998 18C12.9944 18 13.9482 17.6049 14.6515 16.9017C15.3547 16.1984 15.7498 15.2446 15.7498 14.25C15.7498 13.2554 15.3547 12.3016 14.6515 11.5983C13.9482 10.8951 12.9944 10.5 11.9998 10.5ZM9.74983 14.25C9.74983 13.6533 9.98688 13.081 10.4088 12.659C10.8308 12.2371 11.4031 12 11.9998 12C12.5966 12 13.1689 12.2371 13.5908 12.659C14.0128 13.081 14.2498 13.6533 14.2498 14.25C14.2498 14.8467 14.0128 15.419 13.5908 15.841C13.1689 16.2629 12.5966 16.5 11.9998 16.5C11.4031 16.5 10.8308 16.2629 10.4088 15.841C9.98688 15.419 9.74983 14.8467 9.74983 14.25Z" fill="#C9C9C9"/>
            </svg>
        </button>

        <Modal :show="showModalOfferInfo" @close="showModalOfferInfo = false" :isNowrap="true" :modalClass="'offer-details-modal'">
            <div class="offer-details-modal__header">
                <div class="offer-details-modal__header-title">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5933_29097)">
                        <path d="M4.59095 7.82965C4.59095 5.56774 6.4314 3.7273 8.6933 3.7273H16.581C16.2969 2.73324 15.3909 2 14.307 2H4.37504C3.06488 2 2 3.06488 2 4.37504V17.7616C2 19.0718 3.06488 20.1367 4.37504 20.1367H4.59095V7.82965Z" fill="#505050"/>
                        <path d="M18.6244 5.45508H8.69243C7.38227 5.45508 6.31738 6.51996 6.31738 7.83012V20.3531C6.31738 21.6632 7.38227 22.7281 8.69243 22.7281H18.6244C19.9346 22.7281 20.9995 21.6632 20.9995 20.3531V7.83012C20.9995 6.51996 19.9346 5.45508 18.6244 5.45508ZM16.8971 20.1372H10.4197C10.0622 20.1372 9.77199 19.847 9.77199 19.4894C9.77199 19.1319 10.0622 18.8417 10.4197 18.8417H16.8971C17.2547 18.8417 17.5449 19.1319 17.5449 19.4894C17.5449 19.847 17.2547 20.1372 16.8971 20.1372ZM16.8971 16.6826H10.4197C10.0622 16.6826 9.77199 16.3924 9.77199 16.0348C9.77199 15.6773 10.0622 15.3871 10.4197 15.3871H16.8971C17.2547 15.3871 17.5449 15.6773 17.5449 16.0348C17.5449 16.3924 17.2547 16.6826 16.8971 16.6826ZM16.8971 13.6598H10.4197C10.0622 13.6598 9.77199 13.3696 9.77199 13.012C9.77199 12.6545 10.0622 12.3643 10.4197 12.3643H16.8971C17.2547 12.3643 17.5449 12.6545 17.5449 13.012C17.5449 13.3696 17.2547 13.6598 16.8971 13.6598ZM16.8971 10.2052H10.4197C10.0622 10.2052 9.77199 9.91498 9.77199 9.55742C9.77199 9.19987 10.0622 8.90969 10.4197 8.90969H16.8971C17.2547 8.90969 17.5449 9.19987 17.5449 9.55742C17.5449 9.91498 17.2547 10.2052 16.8971 10.2052Z" fill="#505050"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_5933_29097">
                        <rect width="18.9997" height="20.7276" fill="white" transform="translate(2 2)"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <span>{{ mobile ? $t('Details') : $t('Offer Details') }}</span>
                </div>
                <div class="offer-details-modal__header-right">
                    <button @click="showModalOfferInfo = false" type="button" class="main-card__close-btn close" data-dismiss="modal" aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.0486 0.334961C14.4949 -0.111352 15.2185 -0.111352 15.6648 0.334961C16.1111 0.781274 16.1111 1.50486 15.6648 1.95117L9.61597 8L15.6648 14.0488C16.1111 14.4951 16.1111 15.2187 15.6648 15.665C15.2185 16.1114 14.4949 16.1114 14.0486 15.665L7.99976 9.61621L1.95093 15.665C1.50461 16.1114 0.78103 16.1114 0.334717 15.665C-0.111596 15.2187 -0.111597 14.4951 0.334717 14.0488L6.38354 8L0.334717 1.95117C-0.111597 1.50486 -0.111597 0.781274 0.334717 0.334961C0.78103 -0.111353 1.50461 -0.111353 1.95093 0.334961L7.99976 6.38379L14.0486 0.334961Z" fill="#C9C9C9"/>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="offer-details-modal__body">
                <div class="offer-details-modal__body-top">
                    <div class="offer-details-modal__body-top-img">
                        <img :src="product.images.icon_1200x600.src" :alt="product.images.icon_1200x600.alt">
                    </div>
                    <div class="offer-details-modal__body-top-info" :class="{'online-game': isOnlineGame}">
                        <template v-if="isOnlineGame">
                            <div class="atribute-title">
                                {{ decodeHtmlEntities(offer.name) }}
                            </div>
                            <div class="flex-row">
                                <div class="flex-column">
                                    <div class="flex-item title" v-if="offer?.additional_data?.game_server">
                                        <img src="/img/pages/product/icons/server.svg" alt="server">
                                        {{ $t('Server') }}:
                                    </div>
                                    <div class="flex-item title" v-if="offer?.additional_data?.game_fraction">
                                        <img src="/img/pages/product/icons/faction.svg" alt="faction">
                                        {{ $t('Faction') }}:
                                    </div>
                                    <div class="flex-item title" v-if="offer?.warranty_period_title">
                                        <img src="/img/pages/product/icons/warranty.svg" alt="warranty">
                                        {{ $t('Warranty') }}:
                                    </div>
                                    <div v-if="offer" class="flex-item title">
                                        <img src="/img/pages/product/icons/box.svg" alt="box">
                                        {{ $t('Min amount') }}:
                                    </div>
                                </div>
                                <div class="flex-column">
                                    <div class="flex-item" v-if="offer?.additional_data?.game_server">
                                        {{ offer.additional_data.game_server }}
                                    </div>
                                    <div class="flex-item" v-if="offer?.additional_data?.game_fraction">
                                        {{ offer?.additional_data?.game_fraction }}
                                    </div>
                                    <div class="flex-item" v-if="offer?.warranty_period_title">
                                        {{ offer.warranty_period_title }}
                                    </div>
                                    <div class="flex-item" v-if="offer" >
                                        {{ offer.min_order_quantity + (productData?.currency_unit ? productData?.currency_unit : '') + ' ' + productData?.game_currency }}
                                    </div>
                                </div>
                            </div>
                        </template>
                        <DynamicAttributes v-else :offer="offer" :isOnlineGame="isOnlineGame" :showId="false"/>
                        <div class="flex-row" v-if="isOnlineGame && mobile">
                            <div class="flex-column">
                                <div class="flex-item title" v-if="offer?.delivery_time_title">
                                    <img src="/img/pages/product/icons/delivery.svg" alt="delivery">
                                    {{ $t('Delivery') }}:
                                </div>
                                <div class="flex-item title" v-if="offer?.delivery_methods && offer.delivery_methods.length">
                                    <img src="/img/pages/product/icons/truck.svg" alt="truck">
                                    {{ $t('Delivery method') }}:
                                </div>
                            </div>
                            <div class="flex-column">
                                <div class="flex-item" v-if="offer?.delivery_time_title">
                                    {{ offer.delivery_time_title }}
                                </div>
                                <div class="flex-item" v-if="offer?.delivery_methods && offer.delivery_methods.length">
                                    {{ offer.delivery_methods.map(method => method.name).join(', ') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="offer-details-modal__description" v-if="offer?.description && mobile">
                        <div class="offer-details-modal__description-block">
                            <div class="offer-details-modal__description-text" v-html="offer.description"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="offer-details-modal__body-bottom" :class="{'discount': offer?.coupon}">
                <div class="offer-details-modal__body-bottom-discount" v-if="offer?.coupon && mobile" @click.stop="copyToClipboard(offer.coupon.code)">
                    <div class="bottom-discount__left">
                        <span class="bottom-discount__left-title">{{ $t('Discount') }}:</span>
                        <span class="bottom-discount__left-percent">{{ '-'+offer.coupon.value+ ' %' }}</span>
                    </div>
                    <div class="bottom-discount__right">
                        <span class="bottom-discount__right-code">{{ offer.coupon.code }}</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_970_444478)">
                            <path d="M11.3333 12.167C11.3333 12.609 11.1577 13.0329 10.8451 13.3455C10.5326 13.6581 10.1087 13.8337 9.66663 13.8337H3.83329C3.39127 13.8337 2.96734 13.6581 2.65478 13.3455C2.34222 13.0329 2.16663 12.609 2.16663 12.167V6.33366C2.16663 5.89163 2.34222 5.46771 2.65478 5.15515C2.96734 4.84259 3.39127 4.66699 3.83329 4.66699V5.50033C3.61228 5.50033 3.40032 5.58812 3.24404 5.7444C3.08776 5.90068 2.99996 6.11265 2.99996 6.33366V12.167C2.99996 12.388 3.08776 12.6 3.24404 12.7562C3.40032 12.9125 3.61228 13.0003 3.83329 13.0003H9.66663C9.88764 13.0003 10.0996 12.9125 10.2559 12.7562C10.4122 12.6 10.5 12.388 10.5 12.167H11.3333Z" fill="#505050"/>
                            <path d="M6.33329 3.00033C6.11228 3.00033 5.90032 3.08812 5.74404 3.2444C5.58776 3.40068 5.49996 3.61265 5.49996 3.83366V9.66699C5.49996 9.88801 5.58776 10.1 5.74404 10.2562C5.90032 10.4125 6.11228 10.5003 6.33329 10.5003H12.1666C12.3876 10.5003 12.5996 10.4125 12.7559 10.2562C12.9122 10.1 13 9.88801 13 9.66699V3.83366C13 3.61265 12.9122 3.40068 12.7559 3.2444C12.5996 3.08812 12.3876 3.00033 12.1666 3.00033H6.33329ZM6.33329 2.16699H12.1666C12.6087 2.16699 13.0326 2.34259 13.3451 2.65515C13.6577 2.96771 13.8333 3.39163 13.8333 3.83366V9.66699C13.8333 10.109 13.6577 10.5329 13.3451 10.8455C13.0326 11.1581 12.6087 11.3337 12.1666 11.3337H6.33329C5.89127 11.3337 5.46734 11.1581 5.15478 10.8455C4.84222 10.5329 4.66663 10.109 4.66663 9.66699V3.83366C4.66663 3.39163 4.84222 2.96771 5.15478 2.65515C5.46734 2.34259 5.89127 2.16699 6.33329 2.16699Z" fill="#505050"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_970_444478">
                            <rect width="14.6667" height="14.6667" fill="white" transform="translate(0.666626 0.666992)"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="offer-details-modal__body-price">
                    <div class="offer-details-modal__body-price-title" v-if="!mobile">
                        <span class="offer-details-modal__body-price-line"></span>
                        <span class="offer-details-modal__body-price-text">{{ $t('Price') }}</span>
                        <span class="offer-details-modal__body-price-line"></span>
                    </div>
                    <div class="flex-row" v-if="isOnlineGame && !mobile">
                        <div class="flex-column">
                            <div class="flex-item title" v-if="offer?.delivery_time_title">
                                <img src="/img/pages/product/icons/delivery.svg" alt="delivery">
                                {{ $t('Delivery') }}:
                            </div>
                            <div class="flex-item title" v-if="offer?.delivery_methods && offer.delivery_methods.length">
                                <img src="/img/pages/product/icons/truck.svg" alt="truck">
                                {{ $t('Delivery method') }}:
                            </div>
                        </div>
                        <div class="flex-column">
                            <div class="flex-item" v-if="offer?.delivery_time_title">
                                {{ offer.delivery_time_title }}
                            </div>
                            <div class="flex-item" v-if="offer?.delivery_methods && offer.delivery_methods.length">
                                {{ offer.delivery_methods.map(method => method.name).join(', ') }}
                            </div>
                        </div>
                    </div>
                    <div class="offer-details-modal__body-price-amount" :class="{'online-game': isOnlineGame}">
                        <div class="offer-details-modal__body-price-amount-title" :class="{'discount-offer': offer?.coupon}">
                            <span v-html="isOnlineGame ?  `${$t('Price in')} <b>${offer?.offer_price.currency.symbol}</b> / ${offer?.min_order_quantity} <b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency}` : (mobile ? `${$t('Total')}:` : `${$t('Total amount')}:`)"></span>
                            <div class="discount-offer__percent" v-if="offer?.coupon && !mobile" @click.stop="copyToClipboard(offer.coupon.code)">
                                <span>{{ '-'+offer.coupon.value+ ' % ' + offer.coupon.code }}</span>
                                <img class="copy-button" src="/img/pages/product/icons/copy-green.svg" alt="copy">
                            </div>
                        </div>
                        <div class="offer-details-modal__body-price-amount-value" :class="{'discount-offer': offer?.coupon}">
                            <template v-if="offer?.coupon">
                                <span class="discount-offer__old-price">{{formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}</span>
                                <span class="discount-offer__new-price">{{formatCouponePrice(offer.offer_price.price, offer.offer_price.currency.symbol, offer.coupon.value, offer.min_order_quantity)}}</span>
                            </template>
                            <template v-else>
                                <span>{{formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}</span>
                            </template>
                            <PayButtons v-if="!isOnlineGame && product.payment_methods.length" :paymentMethods="product.payment_methods" @pay="goToCheckout($event)"/>
                        </div>
                    </div>
                    <div class="offer-details-modal__body-price-amount stock" v-if="isOnlineGame">
                        <div class="offer-details-modal__body-price-amount-title">
                            <span v-html="`${$t('In Stock')} (<b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency})`"></span>
                        </div>
                        <div class="offer-details-modal__body-price-amount-value" v-if="offer">{{formatCurrency(offer.stock, productData?.currency_unit, true)}}</div>
                    </div>
                </div>
                <div class="offer-details-modal__body-btn">
                    <button class="btn btn__add-to-card" v-if="offer.user.id === userId"
                        @click="redirectToOffer(offer.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M20.71 7.04055C21.1 6.65055 21.1 6.00055 20.71 5.63055L18.37 3.29055C18 2.90055 17.35 2.90055 16.96 3.29055L15.12 5.12055L18.87 8.87055M3 17.2506V21.0006H6.75L17.81 9.93055L14.06 6.18055L3 17.2506Z" fill="#F75A01"/>
                        </svg>
                        <span>
                            {{ $t('Edit') }} 
                        </span>
                    </button>
                    <template v-else>
                        <button class="btn btn__add-to-card" @click="showModalOfferInfo = false" v-if="mobile">
                            <span>{{ $t('Continue shopping') }}</span>
                        </button>
                        <button 
                            v-else
                            class="btn btn__add-to-card"
                            :class="{
                                remove: offer.is_added_to_cart,
                                add: !offer.is_added_to_cart,
                                online: isOnlineGame,
                                preload: loadBtn
                                }"
                            @click="addRemoveOfferToCart(offer.id, !offer.is_added_to_cart)">
                            <svg v-if="offer.is_added_to_cart" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.958 9.14395L18.6429 18.8939C18.6161 19.7289 18.2721 20.5204 17.6839 21.1003C17.0957 21.6802 16.3096 22.0029 15.4925 22H9.50669C8.69012 22.003 7.90451 21.6807 7.31639 21.1015C6.72828 20.5222 6.3839 19.7316 6.35626 18.8971L6.04122 9.14395C6.03432 8.93037 6.11069 8.72273 6.25353 8.56672C6.39636 8.41071 6.59395 8.31911 6.80284 8.31206C7.01172 8.30501 7.21479 8.3831 7.36737 8.52914C7.51995 8.67518 7.60954 8.87721 7.61643 9.0908L7.93148 18.8431C7.94717 19.2595 8.12003 19.6534 8.41375 19.9422C8.70748 20.2309 9.09922 20.3921 9.50669 20.3918H15.4925C15.9005 20.392 16.2927 20.2304 16.5865 19.941C16.8803 19.6515 17.0528 19.2568 17.0677 18.8399L17.3828 9.0908C17.3897 8.87721 17.4793 8.67518 17.6318 8.52914C17.7844 8.3831 17.9875 8.30501 18.1964 8.31206C18.4053 8.31911 18.6029 8.41071 18.7457 8.56672C18.8885 8.72273 18.9649 8.93037 18.958 9.14395ZM20 5.89934C20 6.11292 19.917 6.31776 19.7693 6.46878C19.6216 6.61981 19.4213 6.70465 19.2124 6.70465H5.78761C5.57872 6.70465 5.37839 6.61981 5.23068 6.46878C5.08298 6.31776 5 6.11292 5 5.89934C5 5.68576 5.08298 5.48092 5.23068 5.3299C5.37839 5.17887 5.57872 5.09402 5.78761 5.09402H8.22919C8.47875 5.09471 8.71962 5.00044 8.90495 4.82956C9.09027 4.65867 9.20679 4.4234 9.23182 4.16952C9.28994 3.57398 9.56282 3.0219 9.99729 2.62083C10.4318 2.21977 10.9967 1.99845 11.582 2.00001H13.4172C14.0025 1.99845 14.5674 2.21977 15.0019 2.62083C15.4364 3.0219 15.7093 3.57398 15.7674 4.16952C15.7924 4.4234 15.9089 4.65867 16.0943 4.82956C16.2796 5.00044 16.5205 5.09471 16.77 5.09402H19.2116C19.4205 5.09402 19.6208 5.17887 19.7685 5.3299C19.9162 5.48092 19.9992 5.68576 19.9992 5.89934H20ZM10.5991 5.09402H14.4017C14.2982 4.85222 14.2305 4.59601 14.2008 4.33381C14.1813 4.1353 14.0904 3.95127 13.9458 3.81737C13.8012 3.68347 13.6131 3.60922 13.418 3.60903H11.5828C11.3877 3.60922 11.1996 3.68347 11.055 3.81737C10.9103 3.95127 10.8195 4.1353 10.7999 4.33381C10.77 4.59605 10.7029 4.85227 10.5991 5.09402ZM11.3922 17.2953V10.4381C11.3922 10.2245 11.3092 10.0197 11.1615 9.86864C11.0138 9.71762 10.8135 9.63277 10.6046 9.63277C10.3957 9.63277 10.1954 9.71762 10.0477 9.86864C9.89999 10.0197 9.81701 10.2245 9.81701 10.4381V17.2986C9.81701 17.5121 9.89999 17.717 10.0477 17.868C10.1954 18.019 10.3957 18.1039 10.6046 18.1039C10.8135 18.1039 11.0138 18.019 11.1615 17.868C11.3092 17.717 11.3922 17.5121 11.3922 17.2986V17.2953ZM15.1838 17.2953V10.4381C15.1838 10.2245 15.1008 10.0197 14.9531 9.86864C14.8054 9.71762 14.6051 9.63277 14.3962 9.63277C14.1873 9.63277 13.9869 9.71762 13.8392 9.86864C13.6915 10.0197 13.6086 10.2245 13.6086 10.4381V17.2986C13.6086 17.5121 13.6915 17.717 13.8392 17.868C13.9869 18.019 14.1873 18.1039 14.3962 18.1039C14.6051 18.1039 14.8054 18.019 14.9531 17.868C15.1008 17.717 15.1838 17.5121 15.1838 17.2986V17.2953Z" fill="#F43232"/>
                            </svg>
                            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6019 16.6685C18.6019 16.9527 18.3752 17.1759 18.0869 17.1759H8.23263C7.37759 17.1759 6.6875 16.496 6.6875 15.6539C6.6875 14.8828 7.26428 14.2435 8.02652 14.1522C8.08834 14.1318 8.16048 14.1318 8.23263 14.1318C8.35614 14.1318 8.47978 14.1827 8.56226 14.2638L8.25315 15.1466C8.24296 15.1466 8.24296 15.1466 8.23263 15.1466C7.94418 15.1466 7.71754 15.3697 7.71754 15.6539C7.71754 15.938 7.94418 16.1613 8.23263 16.1613H18.0869C18.3752 16.1613 18.6019 16.3844 18.6019 16.6685Z" fill="#F75A01"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.41801 7.03049C6.45073 7.07104 7.00538 7.3178 7.56378 7.55941C7.5658 7.51568 7.57143 7.47236 7.56137 7.42771L7.10824 5.39828C7.05634 5.16539 6.84714 5 6.60522 5H3.51509C3.23039 5 3 5.22695 3 5.50739C3 5.7877 3.23039 6.01465 3.51509 6.01465H6.19124L6.41801 7.03049Z" fill="#F75A01"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.602 16.6684C18.602 16.9525 18.3754 17.1758 18.0871 17.1758H13.2422V16.1611H18.0871C18.3754 16.1611 18.602 16.3842 18.602 16.6684Z" fill="#F75A01"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.477 7.23233C20.374 7.10037 20.2297 7.0293 20.0649 7.0293H6.41992L8.02688 14.1523L8.25351 15.1467H18.0048C18.2314 15.1467 18.4374 14.9944 18.4992 14.7814L20.5593 7.67869C20.6006 7.52652 20.5696 7.35399 20.477 7.23233Z" fill="#F75A01"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5591 7.67869L18.499 14.7814C18.4372 14.9944 18.2312 15.1467 18.0046 15.1467H13.2422V7.0293H20.0647C20.2295 7.0293 20.3738 7.10037 20.4768 7.23233C20.5694 7.35399 20.6004 7.52652 20.5591 7.67869Z" fill="#F75A01"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.005 19.0004C9.32368 19.0004 8.76953 18.4544 8.76953 17.7834C8.76953 17.1123 9.32368 16.5664 10.005 16.5664C10.6862 16.5664 11.2404 17.1123 11.2404 17.7834C11.2404 18.4544 10.6862 19.0004 10.005 19.0004Z" fill="#F75A01"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.046 19.0004C15.3648 19.0004 14.8105 18.4544 14.8105 17.7834C14.8105 17.1123 15.3648 16.5664 16.046 16.5664C16.7272 16.5664 17.2815 17.1123 17.2815 17.7834C17.2815 18.4544 16.7272 19.0004 16.046 19.0004Z" fill="#F75A01"/>
                            </svg>
                            <span>{{ offer.is_added_to_cart ? $t('Remove from Cart') : $t('Add to Cart') }}</span>
                        </button>
                        
                        <a v-if="!isOnlineGame && !offer?.is_own_offer" 
                            href="/checkout" 
                            class="btn btn__go-cheсkout"
                            @click.prevent="goToCheckout()"><span>{{ mobile ? $t('Cheсkout now') : $t('Go to Checkout') }}</span>
                        </a>
                    </template>
                </div>
            </div>
            <div class="offer-details-modal__description" v-if="offer?.description && !mobile">
                <ScrollFade class="offer-details-modal__description-block" fade-top-class="faded-top" fade-bottom-class="faded">
                    <div class="offer-details-modal__description-text" v-html="offer.description"></div>
                </ScrollFade>
            </div>
        </Modal>
    </div>
    <div class="offer-details placeholder" v-else></div>
</template>

<script>
import Modal from '../../../../components/Modal.vue';
import PayButtons from './PayButtons.vue';
import DynamicAttributes from './DynamicAttributes.vue';
import ScrollFade from '../../../../components/ScrollFade.vue';
import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";
import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities';

export default {
    components: {
        Modal,
        DynamicAttributes,
        PayButtons,
        ScrollFade
    },
    emits: ['update-cart'],
    props: {
      offer: {
        type: Object,
        required: true
      },
      isOnlineGame: {
        type: Boolean,
        default: false
      },
      isHead: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: Boolean,
        default: false
      },
      mobile: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
            loadBtn: false,
            showModalOfferInfo: false,
            product: window.settings.product,
            productData: window.settings.product.additional_data,
            userId: window.common?.user?.id
        };
    },
    methods: {
        decodeHtmlEntities,
        formatCurrency(amount, symbol, isOnline = false, minAmount = 1) {
            const basePrice = minAmount * amount;
            let formatted = Number(basePrice)
                .toFixed(isOnline ? 0 : 2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                .replace(',', '.');

            if(isOnline) {
                return symbol ? `${formatted} ${symbol}` : `${formatted}`
            } else {
                return `${symbol} ${formatted}`
            }
        },
        capitalizeText(text) {
            if (!text) return '';
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        },
        formatCouponePrice(amount, symbol, code, minAmount = 1) {
            const basePrice = minAmount * amount;
            const discount = (basePrice * code) / 100;
            const newPrice = basePrice - discount;
            const formatted = Number(newPrice)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                .replace(',', '.');
            return `${symbol} ${formatted}`
        },
        copyToClipboard(copyData) {
            let tempTextarea = document.createElement('textarea');
            tempTextarea.value = copyData;
            document.body.appendChild(tempTextarea);
            tempTextarea.select();
            document.execCommand('copy');
            document.body.removeChild(tempTextarea);
            renderAlertVue(this.$t('Promo code has been successfully copied.'), 'success', 2000)
        },
        redirectToOffer(offerId) {
            const url = '/offer/' + offerId;
            window.open(url, '_blank').focus();
        },
        addRemoveOfferToCart(offerId, isAdd, amount = 1) {
            this.loadBtn = true;
            this.$emit('update-cart', { offerId, isAdd, amount });
            
            setTimeout(()=>{
                this.showModalOfferInfo = false;
                this.loadBtn = false
            },500)
        },
        goToCheckout(methodId = null) {
            let amount = this.offer?.min_order_quantity ? this.offer.min_order_quantity : 1;
            const url = `/cart/add/${this.offer.id}?amount=${amount}&buy_now=1`;
            const params = new URLSearchParams(window.location.search);
            const offerCoupon = this.offer.coupon?.code ?? null;
            const couponParam = offerCoupon ?? params.get('coupon');

            const data = couponParam ? { coupon: couponParam } : {};
            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: () => {
                    window.updateMiniCarts(amount, this.offer.id, false, couponParam);

                    const checkoutUrl = methodId
                        ? `/checkout?paymentMethodId=${methodId}`
                        : '/checkout';

                    this.$nextTick(() => {
                        window.location = checkoutUrl;
                    });
                },
                error: (xhr, status, error) => {
                    console.error('Error adding to cart:', error);
                }
            });
        },
    }
};
</script>

<style lang="scss">
    .offer-details-modal{
        max-width: 800px !important;
        @media only screen and (max-width: 767px) {
            height: 100%;
            //max-height: 100% !important;
            position: relative;
            display: flex;
            flex-direction: column;
        }
        &__header{
            background-color: #F6F5FA;
            padding: 12px 20px;
            display: flex;
            justify-content: space-between;
            @media only screen and (max-width: 767px) {
                padding: 15px;
            }
            &-title{
                display: flex;
                align-items: center;
                gap: 15px;
                span{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0px;
                    vertical-align: middle;
                    color: #505050;
                }
            }
            .close{
                position: relative;
                top: 3px;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 1;
                @media only screen and (max-width: 767px) {
                    right: 5px;
                }
            }
        }
        &__body{
            background-color: #fff;
            padding: 20px 20px 0;
            position: relative;
            @media only screen and (max-width: 767px) {
                padding: 0;
                height: calc(100% - 54px);
            }
            .flex-row{
                gap: 20px;
            }
            .flex-item{
                font-size: 14px;
                line-height: 20px;
                @media only screen and (max-width: 767px) {
                    font-size: 16px;
                    line-height: 24px;
                }
            }
            &-top{
                display: flex;
                gap: 10px;
                @media only screen and (max-width: 767px) {
                    flex-direction: column;
                    gap: 0;
                    padding-bottom: 180px;
                    overflow-y: auto;
                    max-height: 100%;
                }
                &-img{
                    max-width: 250px;
                    width: 100%;
                    height: 125px;
                    overflow: hidden;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    @media only screen and (max-width: 767px) {
                        height: auto;
                        max-width: 100%;
                        border-radius: 0;
                        max-height: 212px;
                        min-height: 212px;
                    }
                }
                &-info{
                    @media only screen and (max-width: 767px) {
                        padding: 15px;
                        &.online-game{
                            .flex-row{
                                gap: 0;
                                min-width: none;
                                &:last-child{
                                    padding-top: 5px;
                                    align-items: flex-start;
                                }
                                .flex-column{
                                    width: 50%;
                                    .flex-item{
                                        white-space: normal;
                                    }
                                }
                            }
                        }
                        .flex-row{
                            &.id{
                                margin-top: 5px;
                                justify-content: space-between;
                            }
                            &.align-stretch{
                                margin-top: 0;
                                flex-direction: column;
                                .flex-row{
                                    width: 100%;
                                    justify-content: space-between;
                                    .flex-item{
                                        text-align: right;
                                    }
                                }
                                .divider{
                                    display: none;
                                }
                            }
                            &.full{
                                margin-top: 5px;
                                width: 100%;
                                gap: 0;
                                .flex-column.gap-20{
                                    width: 50%;
                                    .delivery_block{
                                        width: 100%;
                                        max-width: none;
                                    }
                                }
                            }
                        }
                    }
                    .atribute-title{
                        font-size: 14px;
                        padding-bottom: 10px;
                        margin-bottom: 0;
                        border-bottom: none;
                        line-height: 20px;
                        @media only screen and (max-width: 767px) {
                            &.is-modal{
                                padding-bottom: 10px;
                            }
                        }
                    }
                }
            }
        }
        &__body-price{
            padding-top: 20px;
            @media only screen and (max-width: 767px) {
                padding-top: 0;
            }
            &-title{
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 20px;
            }
            &-line{
                display: block;
                width: 100%;
                height: 1px;
                background: #E5E5E5;
            }
            &-text{
                font-family: "Avenir-Next";
                font-weight: 400;
                font-size: 12px;
                line-height: 120%;
                letter-spacing: 0px;
                color: #C9C9C9;
            }
            &-amount{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;
                @media only screen and (max-width: 767px) {
                    padding-bottom: 15px;
                    margin-bottom: 15px;
                    border-bottom: 1px solid #E5E5E5;
                }
                &-title{
                    span{
                        font-family: "Avenir-Next", sans-serif;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 24px;
                        letter-spacing: 0px;
                        color: #9D9D9D;
                        @media only screen and (max-width: 767px) {
                            font-family: "Avenir-Next-DemiBold", sans-serif;
                            font-size: 14px;
                            line-height: 140%;
                        }   
                    }
                    .discount-offer__percent{
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        gap: 5px;
                        transition: 0.5s;                            
                    }
                }
                &-value{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 100;
                    font-size: 24px;
                    line-height: 140%;
                    letter-spacing: 0px;
                    color: #11151A;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    white-space: nowrap;
                    @media only screen and (max-width: 767px) {
                        font-size: 16px;
                    }
                    &.discount-offer{
                        .discount-offer__old-price{
                            font-size: 16px;
                            white-space: nowrap;
                            @media only screen and (max-width: 767px) {
                                font-size: 14px;
                            }
                        }
                        .discount-offer__new-price{
                            font-size: 22px;
                            white-space: nowrap;
                            font-family: "Avenir-Next-DemiBold", sans-serif;
                            @media only screen and (max-width: 767px) {
                                font-size: 16px;
                            }
                        }
                    }
                    &.placeholder{
                        width: 132px;
                        height: 30px;
                        border-radius: 11px;
                    }
                }
                &.online-game{
                    margin-top: 20px;
                    margin-bottom: 5px;
                    @media only screen and (max-width: 767px) {
                        margin-top: 0;
                        margin-bottom: 15px;
                    }
                    .offer-details-modal__body-price-amount-value{
                        font-family: "Avenir-Next", sans-serif;
                        font-weight: 400;
                        font-size: 16px;
                    }
                }
            }
        }
        &__body-btn{
            display: flex;
            gap: 15px;
            .btn{
                width: 100%;
                height: 46px;
                border-radius: 8px;
                background-color: #fff;
                border: 1px solid #F75A01;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                transition: 0.4s;
                span{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-size: 14px;
                    line-height: 140%;
                    letter-spacing: 0px;
                    text-align: center;
                    color: #F75A01;
                    transition: 0.4s;
                }
                svg path{
                    transition: 0.4s;
                }
                &::before {
                    content: "";
                    position: absolute;
                    right: 44%;
                    top: 24%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    -moz-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    width: 21px;
                    height: 21px;
                    background: url("/webpack-assets/img/icons/gray-prelodader.svg") center
                        center no-repeat;
                    background-size: 100%;
                    opacity: 0;
                    transition: opacity 0.4s;
                }
                &.preload {
                    position: relative;
                    svg {
                        opacity: 0;
                    }
                    span {
                        opacity: 0;
                    }
                    &::before {
                        opacity: 1;
                        animation: rot 1s infinite linear;
                    }
                }
                &.online{
                    &::before {
                        right: 50%;
                    }
                }
                &:hover{
                    border: 1px solid #FF843F;
                    svg path,
                    span{
                        color: #FF843F;
                        fill: #FF843F;
                    } 
                }
                &__add-to-card{
                    &.remove{
                        border-color: #F43232;
                        span{
                            color: #F43232;
                        }
                        &:hover{
                            border-color: #C32828;
                            svg path,
                            span{
                                color: #C32828;
                                fill: #C32828;
                            } 
                        }
                    }
                }
                &__go-cheсkout{
                    background-color: #F75A01;
                    span{
                        color: #f6f6f6;
                    }
                    &:hover{
                        background-color: #FF843F;
                        svg path,
                        span{
                            color: #f6f6f6;
                            fill: #f6f6f6;
                        } 
                    }
                }
            }
        }
        &__body-bottom{
            background-color: #fff;
            padding: 0 20px 20px;
            @media only screen and (max-width: 767px) {
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                box-shadow: 0px -5px 15px 0px #00000033;
                border-radius: 16px 16px 0 0;
                padding: 15px;
                z-index: 5;
                &-discount{
                    background: #00B2411A;
                    padding: 10px 15px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .bottom-discount{
                        &__left{
                            display: flex;
                            align-items: center;
                            gap: 5px;
                            &-title{
                                color: #1F1F1F;
                                font-family: "Avenir-Next";
                                font-weight: 400;
                                font-size: 12px;
                                line-height: 120%;
                            }
                            &-percent{
                                color: #00BB8C;
                                font-family: "Avenir-Next-DemiBold", sans-serif;
                                font-weight: 400;
                                font-size: 12px;
                                line-height: 120%;
                            }
                        }
                        &__right{
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            &-code{
                                color: #505050;
                                font-family: "Avenir-Next-DemiBold", sans-serif;
                                font-weight: 400;
                                font-size: 12px;
                                line-height: 120%;
                            }
                        }
                    }
                }
                &.discount{
                    padding: 0;
                    .offer-details-modal__body-price{
                        padding: 15px 15px 0;
                    }
                    .offer-details-modal__body-btn{
                        padding: 0 15px 15px;
                    }
                }
            }
        }
        &__description{
            background-color: #f5f5f5;
            padding: 20px 0;
            @media only screen and (max-width: 767px) {
                padding: 0 15px;
                background-color: transparent;
            }
            &-block{
                max-height: 280px;
                overflow-y: auto;
                padding: 0 30px;
                @media only screen and (max-width: 767px) {
                    padding: 20px 0 0;
                    border-top: 1px solid #E5E5E5;
                    max-height: none;
                }
            }
            &-text{
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0px;
                color: #505050;
                b,
                strong,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-size: 16px;
                }
                @media only screen and (max-width: 767px) {
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .offer-details{
        z-index: 2;
        &.placeholder{
            display: block;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            @media only screen and (max-width: 991px) {
                margin-right: 15px;
            }
            @media only screen and (max-width: 767px) {
                display: none;
            }
        }
        button{
            display: flex;
            align-items: center;
            svg{
                path{
                    transition: 0.4s;
                }
            }
        }
        &:hover{
            svg{
                path{
                    fill: #4E8AFF;
                }
            }
        }
        &.tooltip-btn{
            width: 100%;
            button{
                height: 55px;
                
                padding: 10px 20px;
                background-color: #fff;
                transition: 0.4s;
                width: 100%;
                &:hover{
                    background-color: #4E8AFF1A;
                    span{
                        color: #4E8AFF;
                    }
                }
                span{
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    font-family: "Avenir-Next";
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0px;
                    color: #9D9D9D;
                    transition: 0.4s;
                }  
            }
        }
        &.online{
            @media only screen and (max-width: 1199px) {
                display: none;
            }
        }
    }
</style>